import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "button"]

  connect() {
    this.updateUI()
    
    // Listen for OneSignal ready event
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push((OneSignal) => {
      this.OneSignal = OneSignal
      this.updateUI()
      
      // Add event listeners for subscription changes
      OneSignal.User.PushSubscription.addEventListener("change", () => {
        this.updateUI()
      })
    })
  }

  async updateUI() {
    if (!window.Notification) {
      this.statusTarget.textContent = "Notifications not supported on this browser"
      this.buttonTarget.classList.add('hidden')
      return
    }

    const permission = Notification.permission
    
    if (permission === 'denied') {
      this.statusTarget.textContent = "Notifications are blocked in browser settings"
      this.buttonTarget.textContent = "Blocked"
      this.buttonTarget.disabled = true
      this.buttonTarget.classList.replace('bg-blue-600', 'bg-gray-400')
      return
    }

    if (!this.OneSignal) return

    const isSubscribed = this.OneSignal.User.PushSubscription.optedIn
    
    if (isSubscribed) {
      this.statusTarget.textContent = "Notifications are active on this device"
      this.buttonTarget.textContent = "Disable"
      this.buttonTarget.classList.replace('bg-blue-600', 'bg-red-600')
      this.buttonTarget.classList.replace('hover:bg-blue-700', 'hover:bg-red-700')
    } else {
      this.statusTarget.textContent = "Enable alerts on this browser/device"
      this.buttonTarget.textContent = "Enable"
      this.buttonTarget.classList.replace('bg-red-600', 'bg-blue-600')
      this.buttonTarget.classList.replace('hover:bg-red-700', 'hover:bg-blue-700')
    }
  }

  async toggle() {
    if (!this.OneSignal) return

    const isSubscribed = this.OneSignal.User.PushSubscription.optedIn

    if (isSubscribed) {
      await this.OneSignal.User.PushSubscription.optOut()
    } else {
      // If permission is default, this will trigger the browser prompt
      if (Notification.permission === 'default') {
        await this.OneSignal.Slidedown.showHttpPrompt()
      } else {
        await this.OneSignal.User.PushSubscription.optIn()
      }
    }
    
    this.updateUI()
  }
}
